<ion-header *ngIf="isLoggedIn">
    <header-navbar></header-navbar>
</ion-header>

<ion-content [ngClass]="{ 'has-app-header': isLoggedIn }">
    <router-outlet></router-outlet>
</ion-content>
